import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import useResponsive from "./useResponsive";

const useCatalogueFilters = () => {
  const lang = localStorage.getItem("B2BLanguage") === "ITA" ? "it" : "en";

  const { isMobile } = useResponsive();

  const {
    collectionFilterList,
    continuousFilterList,
    categoryFilterList,
    productTypeFilterList,
    colorFilterList,
    sizeFilterList,
    fittingFilterList,
    closureFilterList,
    hoodFilterList,
    paddingFilterList,
    pocketsFilterList,
    reversibleFilterList,
    sleevesFilterList,
  } = useSelector((state) => state.yodaCatalogue);

  const { colors } = useSelector((state) => state.yodaIdentity);

  const [colorFilterValues, setColorFilterValues] = useState([]);
  const [sizeFilterValues, setSizeFilterValues] = useState([]);
  const [productTypeFilterValues, setProductTypeFilterValues] = useState([]);
  const [categoryFilterValues, setCategoryFilterValues] = useState([]);
  const [collectionFilterValues, setCollectionFilterValues] = useState([]);
  const [continuousFilterValues, setContinuousFilterValues] = useState([]);
  const [fittingFilterValues, setFittingFilterValues] = useState([]);
  const [closureFilterValues, setClosureFilterValues] = useState([]);
  const [hoodFilterValues, setHoodFilterValues] = useState([]);
  const [paddingFilterValues, setPaddingFilterValues] = useState([]);
  const [pocketsFilterValues, setPocketsFilterValues] = useState([]);
  const [reversibleFilterValues, setReversibleFilterValues] = useState([]);
  const [sleevesFilterValues, setSleevesFilterValues] = useState([]);
  const [colorFilterFiltered, setColorFilterFiltered] = useState([]);
  const [allFilterValue, setAllFilterValue] = useState(undefined);
  const [searchText, setSearchText] = useState("");
  const [openFilters, setOpenFilters] = useState([
    "collection",
    "continuous",
    "category",
    "productType",
    "color",
    "fitting",
    "closure",
    "hood",
    "padding",
    "pockets",
    "reversible",
    "sleeves",
    "size",
  ]);
  const [openFilterMobile, setOpenFilterMobile] = useState(null);

  const [hasFilters, setHasFilters] = useState(false);

  const resetScroll = () => {
    if (window) window.scrollTo(0, 0);
    const scrollContainer = document?.getElementById("scrollContainer");
    if (scrollContainer) scrollContainer.scrollTo(0, 0);
  };

  function calculateAllFilter() {
    let allValues = [];

    if (collectionFilterValues && collectionFilterValues.length > 0) {
      collectionFilterValues.forEach((id) => {
        allValues.push({
          id,
          text: collectionFilterList?.filter((f) => f.id === id)[0]
            ?.description,
          type: "collection_",
          value: "collection_" + id,
        });
      });
    }

    if (continuousFilterValues?.length) {
      continuousFilterValues.forEach((id) => {
        allValues.push({
          id,
          text: continuousFilterList?.find((f) => f.id === id)?.description,
          type: "continuous_",
          value: "continuous_" + id,
        });
      });
    }

    if (categoryFilterValues && categoryFilterValues.length > 0) {
      categoryFilterValues.forEach((id) => {
        allValues.push({
          id,
          text: categoryFilterList?.filter((f) => f.id === id)[0]?.description,
          type: "category_",
          value: "category_" + id,
        });
      });
    }

    if (productTypeFilterValues && productTypeFilterValues.length > 0) {
      productTypeFilterValues.forEach((id) => {
        allValues.push({
          id,
          text: productTypeFilterList?.filter((f) => f.id === id)[0]
            ?.description,
          type: "productType_",
          value: "productType_" + id,
        });
      });
    }

    if (colorFilterValues && colorFilterValues.length > 0) {
      colorFilterValues.forEach((id) => {
        const color =
          colorFilterList?.find?.((f) => f.id === id) ||
          colors?.find?.((f) => f.id === id);
        allValues.push({
          id,
          text: `${color?.code} ${
            color?.description?.[lang] ? "- " + color?.description[lang] : ""
          }`,
          type: "color_",
          value: "color_" + id,
        });
      });
    }

    if (fittingFilterValues && fittingFilterValues.length > 0) {
      fittingFilterValues.forEach((id) => {
        allValues.push({
          id,
          text: fittingFilterList?.filter((f) => f.id === id)[0]?.description,
          type: "fitting_",
          value: "fitting_" + id,
        });
      });
    }

    if (closureFilterValues && closureFilterValues.length > 0) {
      closureFilterValues.forEach((id) => {
        allValues.push({
          id,
          text: closureFilterList?.filter((f) => f.id === id)[0]?.description,
          type: "closure_",
          value: "closure_" + id,
        });
      });
    }

    if (hoodFilterValues && hoodFilterValues.length > 0) {
      hoodFilterValues.forEach((id) => {
        allValues.push({
          id,
          text: hoodFilterList?.filter((f) => f.id === id)[0]?.description,
          type: "hood_",
          value: "hood_" + id,
        });
      });
    }

    if (paddingFilterValues && paddingFilterValues.length > 0) {
      paddingFilterValues.forEach((id) => {
        allValues.push({
          id,
          text: paddingFilterList?.filter((f) => f.id === id)[0]?.description,
          type: "padding_",
          value: "padding_" + id,
        });
      });
    }

    if (pocketsFilterValues && pocketsFilterValues.length > 0) {
      pocketsFilterValues.forEach((id) => {
        allValues.push({
          id,
          text: pocketsFilterList?.filter((f) => f.id === id)[0]?.description,
          type: "pockets_",
          value: "pockets_" + id,
        });
      });
    }

    if (reversibleFilterValues && reversibleFilterValues.length > 0) {
      reversibleFilterValues.forEach((id) => {
        allValues.push({
          id,
          text: reversibleFilterList?.filter((f) => f.id === id)[0]
            ?.description,
          type: "reversible_",
          value: "reversible_" + id,
        });
      });
    }

    if (sleevesFilterValues && sleevesFilterValues.length > 0) {
      sleevesFilterValues.forEach((id) => {
        allValues.push({
          id,
          text: sleevesFilterList?.filter((f) => f.id === id)[0]?.description,
          type: "sleeves_",
          value: "sleeves_" + id,
        });
      });
    }

    if (sizeFilterValues && sizeFilterValues.length > 0) {
      sizeFilterValues.forEach((id) => {
        allValues.push({
          id,
          text: sizeFilterList?.filter((f) => f.id === id)[0]?.description,
          type: "size_",
          value: "size_" + id,
        });
      });
    }

    if (searchText.length !== 0) {
      allValues.push({
        id: searchText.length,
        text: searchText,
        type: "search_",
        value: "search_" + searchText.length,
      });
    }

    setAllFilterValue(allValues);
  }

  function removeFilter(documentId) {
    const [type, id] = documentId?.split?.("_") || ["", ""];
    const screenElement = document.getElementById(documentId);

    if (screenElement) {
      screenElement.click();
    }

    if (type === "collection") {
      let newValues = [...collectionFilterValues];
      newValues.splice(newValues.indexOf(Number(id)), 1);
      setCollectionFilterValues(newValues);
    }
    if (type === "continuous") {
      let newValues = [...continuousFilterValues];
      newValues.splice(newValues.indexOf(Number(id)), 1);
      setContinuousFilterValues(newValues);
    }
    if (type === "category") {
      let newValues = [...categoryFilterValues];
      newValues.splice(newValues.indexOf(Number(id)), 1);
      setCategoryFilterValues(newValues);
    }
    if (type === "productType") {
      let newValues = [...productTypeFilterValues];
      newValues.splice(newValues.indexOf(id), 1);
      setProductTypeFilterValues(newValues);
    }
    if (type === "color") {
      let newValues = [...colorFilterValues];
      newValues.splice(newValues.indexOf(Number(id)), 1);
      const colorInput = document.getElementById("colorTextFilter");
      if (colorInput) colorInput.value = "";
      setColorFilterValues(newValues);
      setColorFilterFiltered(colorFilterList);
    }
    if (type === "fitting") {
      let newValues = [...fittingFilterValues];
      newValues.splice(newValues.indexOf(id), 1);
      setFittingFilterValues(newValues);
    }
    if (type === "closure") {
      let newValues = [...closureFilterValues];
      newValues.splice(newValues.indexOf(id), 1);
      setClosureFilterValues(newValues);
    }
    if (type === "hood") {
      let newValues = [...hoodFilterValues];
      newValues.splice(newValues.indexOf(id), 1);
      setHoodFilterValues(newValues);
    }
    if (type === "padding") {
      let newValues = [...paddingFilterValues];
      newValues.splice(newValues.indexOf(id), 1);
      setPaddingFilterValues(newValues);
    }
    if (type === "pockets") {
      let newValues = [...pocketsFilterValues];
      newValues.splice(newValues.indexOf(id), 1);
      setPocketsFilterValues(newValues);
    }
    if (type === "reversible") {
      let newValues = [...reversibleFilterValues];
      newValues.splice(newValues.indexOf(id), 1);
      setReversibleFilterValues(newValues);
    }
    if (type === "sleeves") {
      let newValues = [...sleevesFilterValues];
      newValues.splice(newValues.indexOf(id), 1);
      setSleevesFilterValues(newValues);
    }
    if (type === "size") {
      let newValues = [...sizeFilterValues];
      newValues.splice(newValues.indexOf(Number(id)), 1);
      setSizeFilterValues(newValues);
    }
    if (type === "search") {
      setSearchText("");
      setSizeFilterValues([]);
      // if (!isMobile)
      // inputSearchRef.current.value = "";
    }
    calculateAllFilter();
    resetScroll();
  }

  function removeAllFilters() {
    setCollectionFilterValues([]);
    setCategoryFilterValues([]);
    setProductTypeFilterValues([]);
    setColorFilterValues([]);
    setFittingFilterValues([]);
    setClosureFilterValues([]);
    setHoodFilterValues([]);
    setPaddingFilterValues([]);
    setPocketsFilterValues([]);
    setReversibleFilterValues([]);
    setSleevesFilterValues([]);
    setSizeFilterValues([]);
    setSearchText("");
    setAllFilterValue([]);
    setContinuousFilterValues([]);
    setColorFilterFiltered(undefined);
    resetScroll();
    // if (inputSearchRef.current) inputSearchRef.current.value = "";

    const colorInput = document.getElementById("colorTextFilter");
    if (colorInput?.value) colorInput.value = "";
  }

  function toggleFilter(name) {
    const isAlreadySelected = openFilters.some((filter) => filter === name);
    if (isAlreadySelected) {
      setOpenFilters(openFilters.filter((filter) => filter !== name));
    } else {
      setOpenFilters([...openFilters, name]);
    }
  }

  function toggleFilterMobile(name) {
    if (openFilterMobile === name) {
      setOpenFilterMobile(null);
    } else {
      setOpenFilterMobile(name);
    }
  }

  function colorTextFilter(event) {
    let filterValue = event.target.value;
    let tmpArray = colorFilterList.filter(
      (e) => e.code.match(new RegExp(".*" + filterValue + ".*", "g")) !== null,
    );
    setColorFilterFiltered(tmpArray);

    if (event.code === "Enter" && tmpArray.length === 1) {
      if (!colorFilterValues.includes(tmpArray[0].id)) {
        let inserted = [...colorFilterValues, tmpArray[0].id];
        setColorFilterValues(inserted);
        setOpenFilterMobile(null);
        event.target.value = "";
      }
    }
  }

  // setters

  function selectSizeFilter(event) {
    const id = event.target.getAttribute("data-value");
    let newValues = [...sizeFilterValues];

    if (!newValues.includes(Number(id))) {
      newValues.push(Number(id));
    } else {
      newValues.splice(newValues.indexOf(Number(id)), 1);
    }

    setSizeFilterValues(newValues);
    resetScroll();
    setOpenFilterMobile(null);
  }

  function selectColorFilter(event, item) {
    let id;
    if (isMobile) {
      id = item;
    } else {
      id = event.target.getAttribute("data-value");
    }

    let newValues = [...colorFilterValues];

    if (!newValues.includes(Number(id))) {
      newValues.push(Number(id));
    } else {
      newValues.splice(newValues.indexOf(Number(id)), 1);
    }

    setColorFilterValues(newValues);
    resetScroll();
    setOpenFilterMobile(null);
  }

  function selectCollectionFilter(event) {
    const id = event.target.getAttribute("data-value");
    let newValues = [...collectionFilterValues];

    if (event.target.checked) {
      newValues.push(Number(id));
    } else {
      newValues.splice(newValues.indexOf(Number(id)), 1);
    }

    setCollectionFilterValues(newValues);
    resetScroll();
    setOpenFilterMobile(null);
  }

  function selectContinuousFilter(event) {
    const id = event.target.getAttribute("data-value");
    let newValues = [...continuousFilterValues];

    if (event.target.checked) {
      newValues.push(Number(id));
    } else {
      newValues.splice(newValues.indexOf(Number(id)), 1);
    }

    setContinuousFilterValues(newValues);
    resetScroll();
    setOpenFilterMobile(null);
  }

  function selectCategoryFilter(event) {
    const id = event.target.getAttribute("data-value");
    let newValues = [...categoryFilterValues];

    if (event.target.checked) {
      newValues.push(Number(id));
    } else {
      newValues.splice(newValues.indexOf(Number(id)), 1);
    }

    setCategoryFilterValues(newValues);
    resetScroll();
    setOpenFilterMobile(null);
  }

  function selectProductTypeFilter(event) {
    const id = event.target.getAttribute("data-value");
    let newValues = [...productTypeFilterValues];
    if (event.target.checked) {
      newValues.push(id);
    } else {
      newValues.splice(newValues.indexOf(id), 1);
    }

    setProductTypeFilterValues(newValues);
    resetScroll();
    setOpenFilterMobile(null);
  }

  function selectFittingFilter(event) {
    const id = event.target.getAttribute("data-value");
    let newValues = [...fittingFilterValues];
    if (event.target.checked) {
      newValues.push(id);
    } else {
      newValues.splice(newValues.indexOf(id), 1);
    }

    setFittingFilterValues(newValues);
    resetScroll();
    setOpenFilterMobile(null);
  }

  function selectClosureFilter(event) {
    const id = event.target.getAttribute("data-value");
    let newValues = [...closureFilterValues];
    if (event.target.checked) {
      newValues.push(id);
    } else {
      newValues.splice(newValues.indexOf(id), 1);
    }

    setClosureFilterValues(newValues);
    resetScroll();
    setOpenFilterMobile(null);
  }

  function selectHoodFilter(event) {
    const id = event.target.getAttribute("data-value");
    let newValues = [...hoodFilterValues];
    if (event.target.checked) {
      newValues.push(id);
    } else {
      newValues.splice(newValues.indexOf(id), 1);
    }

    setHoodFilterValues(newValues);
    resetScroll();
    setOpenFilterMobile(null);
  }

  function selectPaddingFilter(event) {
    const id = event.target.getAttribute("data-value");
    let newValues = [...paddingFilterValues];
    if (event.target.checked) {
      newValues.push(id);
    } else {
      newValues.splice(newValues.indexOf(id), 1);
    }

    setPaddingFilterValues(newValues);
    resetScroll();
    setOpenFilterMobile(null);
  }

  function selectPocketsFilter(event) {
    const id = event.target.getAttribute("data-value");
    let newValues = [...pocketsFilterValues];
    if (event.target.checked) {
      newValues.push(id);
    } else {
      newValues.splice(newValues.indexOf(id), 1);
    }

    setPocketsFilterValues(newValues);
    resetScroll();
    setOpenFilterMobile(null);
  }

  function selectReversibleFilter(event) {
    const id = event.target.getAttribute("data-value");
    let newValues = [...reversibleFilterValues];
    if (event.target.checked) {
      newValues.push(id);
    } else {
      newValues.splice(newValues.indexOf(id), 1);
    }

    setReversibleFilterValues(newValues);
    resetScroll();
    setOpenFilterMobile(null);
  }

  function selectSleevesFilter(event) {
    const id = event.target.getAttribute("data-value");
    let newValues = [...sleevesFilterValues];
    if (event.target.checked) {
      newValues.push(id);
    } else {
      newValues.splice(newValues.indexOf(id), 1);
    }

    setSleevesFilterValues(newValues);
    resetScroll();
    setOpenFilterMobile(null);
  }

  //effects

  useEffect(() => {
    setHasFilters(false);
    if (
      colorFilterValues.length > 0 ||
      sizeFilterValues.length > 0 ||
      productTypeFilterValues.length > 0 ||
      categoryFilterValues.length > 0 ||
      collectionFilterValues.length > 0 ||
      continuousFilterValues.length > 0 ||
      fittingFilterValues.length > 0 ||
      closureFilterValues.length > 0 ||
      hoodFilterValues.length > 0 ||
      paddingFilterValues.length > 0 ||
      pocketsFilterValues.length > 0 ||
      reversibleFilterValues.length > 0 ||
      sleevesFilterValues.length > 0
    ) {
      setHasFilters(true);
    }
  }, [
    categoryFilterValues,
    collectionFilterValues,
    colorFilterValues,
    productTypeFilterValues,
    sizeFilterValues,
    continuousFilterValues,
    fittingFilterValues,
    closureFilterValues,
    hoodFilterValues,
    paddingFilterValues,
    pocketsFilterValues,
    reversibleFilterValues,
    sleevesFilterValues,
  ]);

  useEffect(() => {
    calculateAllFilter();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    colorFilterValues,
    sizeFilterValues,
    collectionFilterValues,
    continuousFilterValues,
    categoryFilterValues,
    productTypeFilterValues,
    fittingFilterValues,
    closureFilterValues,
    hoodFilterValues,
    paddingFilterValues,
    pocketsFilterValues,
    reversibleFilterValues,
    sleevesFilterValues,
  ]);

  return {
    //methods
    calculateAllFilter,
    removeFilter,
    removeAllFilters,
    toggleFilter,
    toggleFilterMobile,
    colorTextFilter,
    //handlers
    selectSizeFilter,
    selectColorFilter,
    selectCollectionFilter,
    selectContinuousFilter,
    selectCategoryFilter,
    selectProductTypeFilter,
    selectFittingFilter,
    selectClosureFilter,
    selectHoodFilter,
    selectPaddingFilter,
    selectPocketsFilter,
    selectReversibleFilter,
    selectSleevesFilter,
    //state
    colorFilterValues,
    sizeFilterValues,
    productTypeFilterValues,
    categoryFilterValues,
    collectionFilterValues,
    continuousFilterValues,
    fittingFilterValues,
    closureFilterValues,
    hoodFilterValues,
    paddingFilterValues,
    pocketsFilterValues,
    reversibleFilterValues,
    sleevesFilterValues,
    colorFilterFiltered,
    allFilterValue,
    searchText,
    openFilters,
    openFilterMobile,
    hasFilters,
    // setters
    setColorFilterFiltered,
    setSearchText,
  };
};

export default useCatalogueFilters;
